import type { FiatPrice } from "@b2bportal/purchase-api";
import type { CartContext } from "@hopper-b2b/checkout";
import type {
  InstallmentPlan,
  PaymentMethodsResponse,
} from "./api/getPaymentMethods";

export enum PaymentState {
  payment = "payment",
}

export interface NupayCreditInstallment {
  id?: string;
  numOfInstallments: number;
  pricePerInstallment: FiatPrice;
  interest: FiatPrice;
  interestPercent: number;
  total: FiatPrice;
  tax: FiatPrice;
  base: FiatPrice;
}

export interface NubankPaymentContext {
  hasAuth?: boolean;
  redirectUrl?: string;
  error?: { step?: string; details?: unknown };
  paymentMethods: Array<PaymentMethodsResponse>;
  selectedPaymentMethod?: PaymentMethodsResponse;
  selectedCreditInstallment?: InstallmentPlan;
  /** Authorization code from Nupay direct OAuth callback */
  authorizationCode?: string;
  /** Raw OAuth state string from NuPay callback (includes BFF-injected csrfToken) */
  nupayOAuthState?: string;
  /** Payment type from preAuthorize response: "NupayPayment" or "EbanxNupayPayment" */
  paymentType?: string;
}
export interface PaymentContext extends CartContext {
  [PaymentState.payment]: NubankPaymentContext;
}

export const NubankPaymentInitialContext: NubankPaymentContext = {
  hasAuth: undefined,
  error: undefined,
  paymentMethods: [],
};

export const getPaymentInitialContext = () => ({
  [PaymentState.payment]: { ...NubankPaymentInitialContext },
});
